import axios from './axios'
import { IDailySnapshot } from '../@types/Dashboard/IDailySnapshot'
import { IBalanceMovement } from '../@types/Dashboard/IBalanceMovement'

const getDailySnapshot = (
  farmId: number[], 
  areaIds: number[], 
  startDate: string, 
  endDate: string,
  isByBatch: boolean = false,
  signal?: AbortSignal
): Promise<IDailySnapshot[]> => {
  const params = new URLSearchParams();
  farmId.forEach(farm => {
    params.append('farmId', farm.toString());
  });
  areaIds.forEach(areaId => {
    params.append('areaIds', areaId.toString());
  });
  // params.append('farmIds', farmId.map(farm => farm.toString()).toString());
  // params.append('areaIds', areaIds.map(farm => farm.toString()).toString());
  params.append('startDate', startDate);
  params.append('endDate', endDate);
  params.append('isByBatch', isByBatch.toString());

  return axios.get<IDailySnapshot[]>(`/analytics/snapshots/daily-snapshot?${params.toString()}`, { signal }).then(({ data }) => {
    return data
  })
}

const getBalanceMovement = (
  farmIds: number[],
  areaIds: number[],
  startDate: string,
  endDate: string,
  signal?: AbortSignal
): Promise<IBalanceMovement[]> => {
  const params = `farmIds=${farmIds.join(',')}&areaIds=${areaIds.join(',')}&startDate=${startDate}&endDate=${endDate}`;

  return axios.get<IBalanceMovement[]>(`/balance/movement?${params}`, { signal }).then(({ data }) => {
    return data
  })
}

export const analyticsService = {
  getDailySnapshot,
  getBalanceMovement
}
